import { Link } from "react-router-dom";

const entries = [
  {
    title: "电影",
    desc: "院线与网络最新电影",
    count: "8 部精选",
    href: "/category/movie",
    icon: "ri-film-line",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20seats%20and%20glowing%20screen%20in%20the%20dark%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20film%20grain%2C%20atmospheric%20haze%2C%20highly%20detailed%20digital%20painting%2C%20premium%20mood%2C%20no%20typography&width=800&height=500&seq=cat-01&orientation=landscape",
  },
  {
    title: "电视剧",
    desc: "热播剧集与口碑好剧",
    count: "12 部精选",
    href: "/category/tvshow",
    icon: "ri-tv-2-line",
    image:
      "https://readdy.ai/api/search-image?query=Cozy%20living%20room%20at%20night%20with%20a%20single%20warm%20glowing%20lamp%20and%20long%20shadows%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20film%20grain%2C%20atmospheric%20haze%2C%20highly%20detailed%20digital%20painting%2C%20premium%20mood%2C%20no%20typography&width=800&height=500&seq=cat-02&orientation=landscape",
  },
  {
    title: "专题合集",
    desc: "年度大片与热播盘点",
    count: "6 大专题",
    href: "/#topics",
    icon: "ri-bookmark-3-line",
    image:
      "https://readdy.ai/api/search-image?query=Stacked%20vintage%20film%20reels%20and%20glowing%20strip%20of%20film%20curled%20on%20a%20dark%20surface%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20film%20grain%2C%20atmospheric%20haze%2C%20highly%20detailed%20digital%20painting%2C%20premium%20mood%2C%20no%20typography&width=800&height=500&seq=cat-03&orientation=landscape",
  },
];

export default function CategoryEntry() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
        {entries.map((entry) => (
          <Link
            key={entry.title}
            to={entry.href}
            className="group relative block h-[180px] md:h-[210px] rounded-lg overflow-hidden bg-primary-900"
          >
            <img
              src={entry.image}
              alt={`${entry.title}分类`}
              title={`${entry.title} - 绍宋影视`}
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/50 to-foreground-950/20" />
            <div className="relative w-full h-full p-5 flex flex-col justify-end">
              <div className="flex items-center gap-2 mb-2">
                <span className="w-9 h-9 rounded-md bg-accent-500 text-primary-950 flex items-center justify-center">
                  <i className={`${entry.icon} text-xl`} />
                </span>
                <span className="text-xs text-background-200">{entry.count}</span>
              </div>
              <h3 className="font-heading text-xl md:text-2xl font-bold text-background-50">{entry.title}</h3>
              <p className="text-sm text-background-200 mt-1">{entry.desc}</p>
            </div>
            <span className="absolute top-4 right-4 w-9 h-9 rounded-full bg-background-50/10 backdrop-blur border border-background-50/25 flex items-center justify-center text-background-50 opacity-0 group-hover:opacity-100 transition-opacity">
              <i className="ri-arrow-right-up-line text-lg" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}